import React from "react";

import DatePicker from "../../../../Components/DatePicker";
import CommonInput from "../../../../Components/Input";
import TextArea from "../../../../Components/TextArea";
import {
  FORMAL_MAX_DUE_DAYS,
  FORMAL_MIN_DUE_DAYS,
  formalDueMaxInputValue,
  formalDueMinInputValue,
} from "../../../../Utils/Helper/assessmentDueDefaults";

interface Step4Props {
  title: string;
  description: string;
  dueDate: string;
  onUpdateTitle: (title: string) => void;
  onUpdateDescription: (description: string) => void;
  onUpdateDueDate: (dueDate: string) => void;
}

const Step4Configuration: React.FC<Step4Props> = ({
  title,
  description,
  dueDate,
  onUpdateTitle,
  onUpdateDescription,
  onUpdateDueDate,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Assessment Configuration
        </h3>
        <p className="text-gray-600">
          Configure the assessment details and timeline
        </p>
      </div>

      <div>
        <div className="mb-8">
          <CommonInput
            label="Assessment Title"
            name="title"
            type="text"
            value={title}
            onChange={e => {
              if (e.target.value.length <= 100) {
                onUpdateTitle(e.target.value);
              }
            }}
            placeholder="Enter assessment title (max 100 characters)"
            required
            error={title.length > 100 ? "Title too long" : undefined}
          />
          <div className="flex justify-between items-center mt-1">
            <span
              className={`text-xs ${
                title.length > 100
                  ? "text-red-500"
                  : title.length > 80
                    ? "text-yellow-500"
                    : "text-gray-500"
              }`}
            >
              {title.length}/100 characters
            </span>
            {title.length > 100 && (
              <span className="text-xs text-red-500">Title too long</span>
            )}
          </div>
        </div>

        <div className="mb-8">
          <TextArea
            label="Description"
            name="description"
            value={description}
            onChange={e => {
              if (e.target.value.length <= 500) {
                onUpdateDescription(e.target.value);
              }
            }}
            placeholder="Enter assessment description (max 500 characters)"
            rows={3}
            error={
              description.length > 500 ? "Description too long" : undefined
            }
          />
          <div className="flex justify-between items-center mt-1">
            <span
              className={`text-xs ${
                description.length > 500
                  ? "text-red-500"
                  : description.length > 400
                    ? "text-yellow-500"
                    : "text-gray-500"
              }`}
            >
              {description.length}/500 characters
            </span>
          </div>
        </div>

        <div className="mb-8">
          <DatePicker
            label="Due Date"
            name="dueDate"
            value={dueDate}
            onChange={e => onUpdateDueDate(e.target.value)}
            min={formalDueMinInputValue()}
            max={formalDueMaxInputValue()}
            required
          />
          <p className="mt-1 text-xs text-gray-500">
            Pick a due date {FORMAL_MIN_DUE_DAYS} to {FORMAL_MAX_DUE_DAYS} days
            from today.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Step4Configuration;
